import script from "./CustomerDataBoardComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./CustomerDataBoardComponent.vue?vue&type=script&lang=ts&setup=true"

import "./CustomerDataBoardComponent.vue?vue&type=style&index=0&id=aa87b78c&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.3.13_webpack@5.99.5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aa87b78c"]])

export default __exports__